<ion-content>
  <div class="access-denied-container">
    <ion-card>
      <ion-card-header>
        <ion-card-title>Access Denied</ion-card-title>
      </ion-card-header>
      <ion-card-content>
        <p>You do not have permission to access this page.</p>
        <p>Please contact your administrator if you believe this is an error.</p>
        <ion-button color="primary" expand="block" (click)="goBack()">
          Back to Login
        </ion-button>
      </ion-card-content>
    </ion-card>
  </div>
</ion-content>
